export default __webpack_public_path__ + "static/realWorldImg4-0961a86b0cb92031b94b361c3cfce8e6.png";